import { useState } from "react";
import submit from "submit-form";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import { OPTION_NAME_MAP, optionFields } from "../data/getting-started";

const publishOption = ({ workflow, option, optionObj }) => {
  const hasItem = optionObj[optionFields[option]];
  if (!hasItem) {
    return alert("Option cannot be empty before publishing");
  }
  submit(`/actions/getting-started/publish/${workflow}/${option}`, {
    method: "GET",
  });
};

const unpublishOption = ({ workflow, option }) => {
  submit(`/actions/getting-started/unpublish/${workflow}/${option}`, {
    method: "GET",
  });
};

export const GettingStartedOption = ({ option, workflow, optionObj = {} }) => {
  const { status } = optionObj;
  const published = status === "published";
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  const handleChange = () => {
    published
      ? unpublishOption({ workflow, option })
      : publishOption({ workflow, option, optionObj });
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 250);
  };
  return (
    <div className="option">
      <p className="p4">{OPTION_NAME_MAP[option]}</p>

      <div>
        <input
          type="checkbox"
          id={`switch-${option}`}
          name={`switch-${option}`}
          role="switch"
          onChange={() => {
            setOpenedConfirmationModal((prev) => !prev);
          }}
          checked={published}
        />
        <ConfirmationModal
          title={published ? "Unpublish" : "Publish"}
          contentText={`Are you sure you want to ${
            published ? "unpublish" : "publish"
          } this option?`}
          cancelButtonText="Cancel"
          cancelButtonAction={() => {
            setOpenedConfirmationModal((prev) => !prev);
          }}
          confirmButtonText={published ? "Unpublish" : "Publish"}
          confirmButtonAction={() => handleChange()}
          isOpen={openedConfirmationModal}
          confirmSuccess={!published}
        />
      </div>
    </div>
  );
};
